import InventoryAtPointSummary, { type InventoryBikeRow } from './InventoryAtPointSummary'

export interface BikesSnapshot {
  total: number
  free: number
  inUse: number
  reserved: number
  service: number
  capturedAt?: string
  /** Per-bike list captured at close (newer snapshots). Old snapshots have only counts. */
  bikes?: InventoryBikeRow[]
}

/**
 * Inventory captured at shift close (stored on the shift). Shows what was at the
 * point THEN, frozen. Newer snapshots include the per-bike list → render the full
 * detailed view (same as live). Older snapshots have counts only.
 */
export default function ShiftBikesSnapshot({ snapshot }: { snapshot: BikesSnapshot }) {
  // Newer snapshots carry the full bike list → reuse the live inventory view, frozen.
  if (snapshot.bikes && snapshot.bikes.length > 0) {
    return (
      <div className="space-y-1">
        <InventoryAtPointSummary bikes={snapshot.bikes} />
        <p className="text-[11px] text-gray-400 mt-1">📸 Снимок на момент закрытия смены</p>
      </div>
    )
  }

  // Old snapshots: counts only.
  return (
    <div className="space-y-1">
      <div className="grid grid-cols-2 gap-2 text-sm">
        <div className="bg-green-50 rounded-xl px-3 py-2 flex justify-between">
          <span className="text-gray-600">Свободно</span>
          <span className="font-bold text-green-700">{snapshot.free}</span>
        </div>
        <div className="bg-blue-50 rounded-xl px-3 py-2 flex justify-between">
          <span className="text-gray-600">В аренде</span>
          <span className="font-bold text-blue-700">{snapshot.inUse}</span>
        </div>
        <div className="bg-yellow-50 rounded-xl px-3 py-2 flex justify-between">
          <span className="text-gray-600">Забронировано</span>
          <span className="font-bold text-yellow-700">{snapshot.reserved}</span>
        </div>
        <div className="bg-orange-50 rounded-xl px-3 py-2 flex justify-between">
          <span className="text-gray-600">Сервис</span>
          <span className="font-bold text-orange-700">{snapshot.service}</span>
        </div>
      </div>
      <div className="bg-gray-50 rounded-xl px-3 py-2 flex justify-between text-sm">
        <span className="text-gray-500">Итого на точке</span>
        <span className="font-bold">{snapshot.total}</span>
      </div>
      <p className="text-[11px] text-gray-400 mt-1">📸 Снимок на момент закрытия смены</p>
    </div>
  )
}
